import { createClient } from '@supabase/supabase-js'
import { createAuthTimeoutFetch } from './authRequestTimeout'
import { capturePasswordRecoveryProof } from './passwordRecoveryProof'
import { captureSupportInvitation, cleanSupportInvitationUrl } from './supportInvitationLink'
import { staffSupportEnabled } from './staffSupportRoute'
import { isNativeApp } from './platform'

let passwordRecoveryProof = capturePasswordRecoveryProof(typeof window === 'undefined' ? null : window.location)
export const getPasswordRecoveryProof = () => passwordRecoveryProof
export const clearPasswordRecoveryProof = () => { passwordRecoveryProof = Object.freeze({kind:'absent'}) }

// Capture before Auth startup, React lazy loading and activity telemetry. Reads
// must be pure for StrictMode; only a human verification click consumes proof.
let supportActivationProof = Object.freeze({kind:'invalid'})
if (typeof window !== 'undefined' && staffSupportEnabled(window.location.hostname,isNativeApp()) &&
    new URLSearchParams(window.location.search).get('screen') === 'support-activate' && passwordRecoveryProof.kind !== 'recovery') {
  supportActivationProof = captureSupportInvitation(window.location)
  cleanSupportInvitationUrl(window.location,window.history)
}
export const getSupportActivationProof = () => supportActivationProof
export const consumeSupportActivationProof = () => {
  const proof = supportActivationProof
  supportActivationProof = Object.freeze({kind:'consumed'})
  return proof
}


export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://rxjrcbdeyouafhtizneh.supabase.co'
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ4anJjYmRleW91YWZodGl6bmVoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM1Mjk1MjIsImV4cCI6MjA4OTEwNTUyMn0.yDgjAGZK3g-GR4GvlM-JOh2rfsYXRIW-_RwLt9lfi70'

const authTimeoutFetch = createAuthTimeoutFetch((input,init) => globalThis.fetch(input,init), `${SUPABASE_URL}/auth/v1/`)

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  global: {fetch:authTimeoutFetch},
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
  }
})

